import PennsylvaniaHeroSection from "./components/HeroSection";
import PennsylvaniaCitiesDirectory from "./components/CitiesDirectory";
import PennsylvaniaStateResources from "./components/StateResources";
import PennsylvaniaFAQSection, { faqs } from "./components/FAQSection";
import PennsylvaniaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const seoFaqs = faqs.map(f => ({ q: f.question, a: f.answer }));

export default function PennsylvaniaPage() {
  return (
    <>
      <CitySEOHead
        city="Pennsylvania"
        state="Pennsylvania"
        stateAbbr="PA"
        route="/states/pennsylvania"
        title="Pennsylvania Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Pennsylvania — Philadelphia, Pittsburgh, Harrisburg, Allentown, Erie. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Pennsylvania, United States"
        geoPosition="40.2698;-77.0274"
        faqs={seoFaqs}
        servicesSchema={servicesList}
      />
      <div className="font-sans">
        <PennsylvaniaHeroSection />
        <PennsylvaniaCitiesDirectory />
        <PennsylvaniaStateResources />
        <PennsylvaniaFAQSection />
        <SEOCrossLinks state="PA" />
        <PennsylvaniaFinalCTA />
      </div>
    </>
  );
}